import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useParams } from 'react-router-dom';

import { DefaultSheet } from 'twyne-new.ui'

import { useAppAlert } from '@Components/AppAlert';
import history from 'utils/history';

import Form from '../components/Form';
import { PublisherProvider, usePublisherStore } from '../store';

const PublisherForm = () => {
  const { id } = useParams()
  const { collection: { item, useLoad, useSubmit, reset } } = usePublisherStore()
  const { handleSuccess, handleError } = useAppAlert()

  useLoad(id)

  const handleSubmit = useSubmit()

  if (!item) return null;

  function handleClose() {
    reset()
    history.push('/offer/publishers')
  }

  async function handleSubmitAndClose(payload) {
    try {
      await handleSubmit(payload)
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `Publisher ${message}.`)
      handleClose()
    } catch (error) {
      if (error.response?.data.includes('Duplicated Name')) {
        handleError('Error', 'Duplicated publisher name.');
      } else {
        handleError('Error', 'Publisher was not saved.');
      }
    }
  }

  return <>
    <DefaultSheet
      wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleClose() }}
      title={item.id ? 'Edit Publisher' : 'Add Publisher'}
    >
      <Helmet title="Publisher" />
      <Form data={item} handleSubmit={handleSubmitAndClose} />
    </DefaultSheet>
  </>
}

PublisherForm.propTypes = {
  match: PropTypes.object,
};

export default function PublisherFormLayout() {
  return <PublisherProvider>
    <PublisherForm />
  </PublisherProvider>
}
